export const valueChain = {
    title: 'Value Chain',
    tooltip:
        'Industries and companies (lead generation, virtual competitors) who are highly interested in the technology related to the theme specified in the UI for each element (development, manufacturing, procurement, service) that constitutes the value chain, and development trends (development, virtual competition) that are highly interested. You can understand the technology cluster). Since the ranking list of innovation evaluation results (score, impact or start-up is stage) of companies that own the technology in the cluster specified in the UI is displayed in the UI, the user has the business scale and round information and the year of establishment. You can create a list of potential alliances with operating companies or start-up companies.',
    valueChainLabel: 'Value Chain',
    naceLabel: 'Process',
    usLabel: 'Industry Classification',
    ipcLabel: 'Select a Cluster',
    filterCompany: 'Select a Company',
    clusterLabel: 'Cluster',
    optional: ' (Optional)',
    chart1XAxisScore: 'Score',
    chart1XAxisImpact: 'Impact',
    chart1YAxisScale: 'Revenue [k USD]',
    chart1YAxisAmount: 'Minority Investment Amount [m JPY]',

    table1Title: 'Innovation Score Table',
    table1CompanyName: 'Company',
    table1Score: 'Score',
    table1Scale: 'Revenue [k USD]',
    table1Impact: 'Impact',
    table1Stage: 'Startup Stages',
    table1BusinessImpace: 'Business Impact',
    table1Amount: 'Minority Investment Amount [m JPY]',
    table1Year: 'Foundation Year',

    table2Title: 'Minority Investment By Cluster',
    table2ToCompany: 'Investment Destination',
    table2FromCompany: 'Investment Source',
    table2Amount: 'Minority Investment Amount [m JPY]',

    chart2Title: 'Startup Phase Evaluation',
    chart2XAxisStage: 'Startup Stages',
    chart2XAxisScore: 'Intellectual Property Innovation Evaluation Score',
    chart2YAxisScale: 'Revenue [k USD]',
    chart2YAxisImpact: 'Business Impact',
    chart2YAxisAmount: 'Minority Investment Amount [m JPY]',

    wordCloudTitle: "Cluster's WordCloud",
    wordCloudBarTitle: "Cluster's Word Frequency",
    xAxis: 'X Axis',
    yAxis: 'Y Axis',
    chart1Title: 'Start Up',
    chartClusterId: 'ClusterID',
    chart3Title: 'Business Company',
    chart1XAxisStage: 'Startup Stages',

    groupBy: 'Group By',
    investmentStatusTable: 'Investment Status',
    companyTableColumn: 'Company',
    naceLabelTableColumn: 'Category_1',
    usLabelTableColumn: 'Category_2',
    targetAmountTableColumn: 'Minority Investment Amount [m JPY]',
    investmentAmountTableColumn: 'Source Amount',

    selectedCompanyWithoutPatent: 'Company without Patent',
    selectedCompanyIncluded: 'Selected Company Included',
    selectedCompanyExcluded: 'Selected Company Excluded',
    selectedCompanyWithLabel: 'Selected Company With Label',
    companyName: 'Company',
    patentcount: 'Number of Patent Application',
    impact: 'Impact',

    target: 'Target',
    investment: 'Investment',
    // Startup without patent
    titleStartUpWithoutPatentTable: 'Startup without Patent',
    filterYear: 'Year of Establishment',
    inYears: 'Within {{n}} Years',
    tblStartUpWithoutPatentCompany: 'Company',
    tblStartUpWithoutPatentOverview: 'Overview',
    tblStartUpWithoutPatentSourceCompany: 'Investment Source Company',
    tblStartUpWithoutPatentAmount: 'Minority Investment Amount [m JPY]',
    tblStartUpWithoutPatentMatch: 'Similarity',

    tblStartUpWithoutPatentMatchYear: 'Foundation Year',

    patentTableTitile: 'Patent List of Selected Company',
    downloadTitle: 'Download the complete list of the patents',
    tableColumnPublication: 'Publication number',
    tableColumnIPCMain: 'Main IPC',
    tableColumnIPCOther: 'Other IPC',
    tableColumnIPCTitle: 'Title',
    tableColumnOwner: 'Patent Owner',
    tableColumnInventor: 'Inventor',
    tableColumnFLQ: 'Factor Load  Quantity',
    tableColumnImpact: 'Impact',
    tableColumnApplicationYear: 'Application Year',

    // Switch btn and RadioGroup
    CompanySelectMode: 'Company Select',
    LabelFixMode: 'Label Fix',
    labelShowMore: 'Company Name, PatentCount',
    labelShowOnlyCluster: 'Company Name only'
}
